import { render } from "./LabelDisclaimer.vue?vue&type=template&id=e5ae1e76&scoped=true"
import script from "./LabelDisclaimer.vue?vue&type=script&lang=js"
export * from "./LabelDisclaimer.vue?vue&type=script&lang=js"

import "./LabelDisclaimer.vue?vue&type=style&index=0&id=e5ae1e76&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ae1e76"]])

export default __exports__